"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "firenze": {
    "bd035292": [{
      "hkey": "d8f44a57",
      "slug": "firenze-nova-novoli",
      "name": "Firenze Nova, Novoli",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "0ecc85cf",
      "slug": "brozzi-le-piagge-peretola-quaracchi",
      "name": "Brozzi-Le Piagge, Peretola, Quaracchi",
      "primary": false,
      "skipSearch": null
    }],
    "38077c0d": [{
      "hkey": "d9e5d59f",
      "slug": "leopoldo-poggetto-statuto-montughi",
      "name": "Leopoldo-Poggetto-Statuto, Montughi",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "e02cb41f",
      "slug": "coverciano",
      "name": "Coverciano",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "87e08f05",
      "slug": "campo-di-marte",
      "name": "Campo Di Marte",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "2ea9c30c",
      "slug": "le-cure",
      "name": "Le Cure",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "7b37799a",
      "slug": "piazza-liberta",
      "name": "Piazza Libertà",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "becc0ffc",
      "slug": "beccaria-mazzini-oberdan",
      "name": "Beccaria, Mazzini-Oberdan",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "b34be071",
      "slug": "faentina-trespiano-bolognese",
      "name": "Faentina, Trespiano, Bolognese",
      "primary": false,
      "skipSearch": null
    }],
    "porta-al-prato": [{
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "4071f245": [{
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "7b37799a",
      "slug": "piazza-liberta",
      "name": "Piazza Libertà",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "becc0ffc",
      "slug": "beccaria-mazzini-oberdan",
      "name": "Beccaria, Mazzini-Oberdan",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "87e08f05",
      "slug": "campo-di-marte",
      "name": "Campo Di Marte",
      "primary": true,
      "skipSearch": false
    }],
    "14c9667c": [{
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "3b0a8ed3",
      "slug": "bagnese-due-strade-galluzzo",
      "name": "Bagnese, Due Strade, Galluzzo",
      "primary": true,
      "skipSearch": null
    }],
    "55dd50d6": [{
      "hkey": "becc0ffc",
      "slug": "beccaria-mazzini-oberdan",
      "name": "Beccaria, Mazzini-Oberdan",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "87e08f05",
      "slug": "campo-di-marte",
      "name": "Campo Di Marte",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "7b37799a",
      "slug": "piazza-liberta",
      "name": "Piazza Libertà",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }],
    "peretola-brozzi": [{
      "hkey": "d8f44a57",
      "slug": "firenze-nova-novoli",
      "name": "Firenze Nova, Novoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "465e46c6": [{
      "hkey": "3b0a8ed3",
      "slug": "bagnese-due-strade-galluzzo",
      "name": "Bagnese, Due Strade, Galluzzo",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "b44005e6",
      "slug": "gavinana-viale-europa",
      "name": "Gavinana, Viale Europa",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "7dcc5eed",
      "slug": "michelangelo",
      "name": "Michelangelo",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "a65f2fee",
      "slug": "firenze-sud-monteripaldi-ponte-a-ema",
      "name": "Firenze Sud, Monteripaldi, Ponte a Ema",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "ac817813",
      "slug": "arcetri-torre-del-gallo",
      "name": "Arcetri, Torre del Gallo",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": true,
      "skipSearch": null
    }],
    "piazza-leopoldo-vittorio-emanuele": [{
      "hkey": "d9e5d59f",
      "slug": "leopoldo-poggetto-statuto-montughi",
      "name": "Leopoldo-Poggetto-Statuto, Montughi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "650326c6": [{
      "hkey": "b34be071",
      "slug": "faentina-trespiano-bolognese",
      "name": "Faentina, Trespiano, Bolognese",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "2ea9c30c",
      "slug": "le-cure",
      "name": "Le Cure",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d9e5d59f",
      "slug": "leopoldo-poggetto-statuto-montughi",
      "name": "Leopoldo-Poggetto-Statuto, Montughi",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "fde7fef6",
      "slug": "settignano",
      "name": "Settignano",
      "primary": false,
      "skipSearch": false
    }],
    "04cbfc25": [{
      "hkey": "d9e5d59f",
      "slug": "leopoldo-poggetto-statuto-montughi",
      "name": "Leopoldo-Poggetto-Statuto, Montughi",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": false,
      "skipSearch": false
    }],
    "f2a815e4": [{
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d9e5d59f",
      "slug": "leopoldo-poggetto-statuto-montughi",
      "name": "Leopoldo-Poggetto-Statuto, Montughi",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": false,
      "skipSearch": null
    }],
    "5e190d46": [{
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "b8854c8f": [{
      "hkey": "bb95ce29",
      "slug": "bellariva",
      "name": "Bellariva",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "8012b831",
      "slug": "varlungo-rovezzano",
      "name": "Varlungo, Rovezzano",
      "primary": false,
      "skipSearch": false
    }],
    "4abfa254": [{
      "hkey": "7dcc5eed",
      "slug": "michelangelo",
      "name": "Michelangelo",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "ac817813",
      "slug": "arcetri-torre-del-gallo",
      "name": "Arcetri, Torre del Gallo",
      "primary": false,
      "skipSearch": false
    }],
    "legnaia-soffiano": [{
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "59d5cb64": [{
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "3b0a8ed3",
      "slug": "bagnese-due-strade-galluzzo",
      "name": "Bagnese, Due Strade, Galluzzo",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "ac817813",
      "slug": "arcetri-torre-del-gallo",
      "name": "Arcetri, Torre del Gallo",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "7dcc5eed",
      "slug": "michelangelo",
      "name": "Michelangelo",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }],
    "l-isolotto": [{
      "hkey": "ffe8e6c2",
      "slug": "isolotto",
      "name": "Isolotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "dae641f7": [{
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "2ea9c30c",
      "slug": "le-cure",
      "name": "Le Cure",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "b34be071",
      "slug": "faentina-trespiano-bolognese",
      "name": "Faentina, Trespiano, Bolognese",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "d9e5d59f",
      "slug": "leopoldo-poggetto-statuto-montughi",
      "name": "Leopoldo-Poggetto-Statuto, Montughi",
      "primary": false,
      "skipSearch": null
    }],
    "25ffe834": [{
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "7dcc5eed",
      "slug": "michelangelo",
      "name": "Michelangelo",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": false,
      "skipSearch": null
    }],
    "f7dbfb7a": [{
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d8f44a57",
      "slug": "firenze-nova-novoli",
      "name": "Firenze Nova, Novoli",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "0ecc85cf",
      "slug": "brozzi-le-piagge-peretola-quaracchi",
      "name": "Brozzi-Le Piagge, Peretola, Quaracchi",
      "primary": false,
      "skipSearch": null
    }],
    "92baa13d": [{
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "becc0ffc",
      "slug": "beccaria-mazzini-oberdan",
      "name": "Beccaria, Mazzini-Oberdan",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "7b37799a",
      "slug": "piazza-liberta",
      "name": "Piazza Libertà",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "87e08f05",
      "slug": "campo-di-marte",
      "name": "Campo Di Marte",
      "primary": true,
      "skipSearch": null
    }],
    "3a5d21b2": [{
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "skipSearch": null
    }],
    "bolognese-le-cure": [{
      "hkey": "b34be071",
      "slug": "faentina-trespiano-bolognese",
      "name": "Faentina, Trespiano, Bolognese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "c228501c": [{
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "827d49f6",
      "slug": "castello-serpiolle",
      "name": "Castello, Serpiolle",
      "primary": false,
      "skipSearch": null
    }],
    "072c8791": [{
      "hkey": "ffe8e6c2",
      "slug": "isolotto",
      "name": "Isolotto",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": null
    }],
    "firenze-sud-gavinana-europa": [{
      "hkey": "b44005e6",
      "slug": "gavinana-viale-europa",
      "name": "Gavinana, Viale Europa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "poggio-imperiale-piazzale-michelangelo-pian-dei-giullari": [{
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a20fed88": [{
      "hkey": "827d49f6",
      "slug": "castello-serpiolle",
      "name": "Castello, Serpiolle",
      "primary": true,
      "skipSearch": false
    }],
    "careggi-dalmazia-serpiolle": [{
      "hkey": "827d49f6",
      "slug": "castello-serpiolle",
      "name": "Castello, Serpiolle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6e6e5685": [{
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": true,
      "skipSearch": false
    }],
    "castello-rifredi": [{
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a7aef795": [{
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": true,
      "skipSearch": false
    }],
    "pitti-oltrarno-porta-romana-san-frediano-santo-spririto": [{
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "87bfa131": [{
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": true,
      "skipSearch": false
    }],
    "careggi-dalmazia": [{
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "cf77d114": [{
      "hkey": "42972f59",
      "slug": "castello",
      "name": "Castello",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "42972f59",
      "slug": "castello",
      "name": "Castello",
      "primary": true,
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "castello-serpiolle"
    }],
    "porta-romana-giardino-di-boboli": [{
      "hkey": "3b0a8ed3",
      "slug": "bagnese-due-strade-galluzzo",
      "name": "Bagnese, Due Strade, Galluzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4898e0cf": [{
      "hkey": "d9e5d59f",
      "slug": "leopoldo-poggetto-statuto-montughi",
      "name": "Leopoldo-Poggetto-Statuto, Montughi",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": false,
      "skipSearch": null
    }],
    "015c61d0": [{
      "hkey": "0ecc85cf",
      "slug": "brozzi-le-piagge-peretola-quaracchi",
      "name": "Brozzi-Le Piagge, Peretola, Quaracchi",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "d8f44a57",
      "slug": "firenze-nova-novoli",
      "name": "Firenze Nova, Novoli",
      "primary": true,
      "skipSearch": null
    }],
    "937cb6a0": [{
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "3b0a8ed3",
      "slug": "bagnese-due-strade-galluzzo",
      "name": "Bagnese, Due Strade, Galluzzo",
      "primary": true,
      "skipSearch": false
    }],
    "michelangelo-porta-romana": [{
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6ebe9fb2": [{
      "hkey": "bb95ce29",
      "slug": "bellariva",
      "name": "Bellariva",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "8012b831",
      "slug": "varlungo-rovezzano",
      "name": "Varlungo, Rovezzano",
      "primary": false,
      "skipSearch": null
    }],
    "campo-di-marte-liberta": [{
      "hkey": "87e08f05",
      "slug": "campo-di-marte",
      "name": "Campo Di Marte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "rifredi-dalmazia-serpiolle-careggi": [{
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "centro-oltrarno-santo-spirito-san-frediano": [{
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b7474790": [{
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "skipSearch": null
    }],
    "05c4d54b": [{
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "7dcc5eed",
      "slug": "michelangelo",
      "name": "Michelangelo",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": true,
      "skipSearch": false
    }],
    "cd8b0b63": [{
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "827d49f6",
      "slug": "castello-serpiolle",
      "name": "Castello, Serpiolle",
      "primary": false,
      "skipSearch": false
    }],
    "9c6799f4": [{
      "hkey": "b44005e6",
      "slug": "gavinana-viale-europa",
      "name": "Gavinana, Viale Europa",
      "primary": true,
      "skipSearch": null
    }, {
      "hkey": "a65f2fee",
      "slug": "firenze-sud-monteripaldi-ponte-a-ema",
      "name": "Firenze Sud, Monteripaldi, Ponte a Ema",
      "primary": false,
      "skipSearch": null
    }],
    "isolotto-talenti": [{
      "hkey": "ffe8e6c2",
      "slug": "isolotto",
      "name": "Isolotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "02b59996": [{
      "hkey": "ffe8e6c2",
      "slug": "isolotto",
      "name": "Isolotto",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": true,
      "skipSearch": false
    }],
    "91418fc6": [{
      "hkey": "ffe8e6c2",
      "slug": "isolotto",
      "name": "Isolotto",
      "primary": true,
      "skipSearch": false
    }],
    "f431f72a": [{
      "hkey": "d8f44a57",
      "slug": "firenze-nova-novoli",
      "name": "Firenze Nova, Novoli",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "0ecc85cf",
      "slug": "brozzi-le-piagge-peretola-quaracchi",
      "name": "Brozzi-Le Piagge, Peretola, Quaracchi",
      "primary": false,
      "skipSearch": false
    }],
    "alberti-bellariva": [{
      "hkey": "bb95ce29",
      "slug": "bellariva",
      "name": "Bellariva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "santa-croce-sant-ambrogio": [{
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bellosguardo": [{
      "hkey": "3b0a8ed3",
      "slug": "bagnese-due-strade-galluzzo",
      "name": "Bagnese, Due Strade, Galluzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "leopoldo": [{
      "hkey": "d9e5d59f",
      "slug": "leopoldo-poggetto-statuto-montughi",
      "name": "Leopoldo-Poggetto-Statuto, Montughi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "e4d04c58": [{
      "hkey": "b34be071",
      "slug": "faentina-trespiano-bolognese",
      "name": "Faentina, Trespiano, Bolognese",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "d9e5d59f",
      "slug": "leopoldo-poggetto-statuto-montughi",
      "name": "Leopoldo-Poggetto-Statuto, Montughi",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "2ea9c30c",
      "slug": "le-cure",
      "name": "Le Cure",
      "primary": false,
      "skipSearch": false
    }],
    "san-domenico-settignano": [{
      "hkey": "fde7fef6",
      "slug": "settignano",
      "name": "Settignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "centro": [{
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "centro-duomo": [{
      "hkey": "02ae613c",
      "slug": "centro-centro-storico",
      "name": "Centro, Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "oltrarno": [{
      "hkey": "b29dc1c6",
      "slug": "pitti-oltrarno-porta-romana-san-frediano-santo-spirito",
      "name": "Pitti-Oltrarno, Porta Romana, San Frediano, Santo Spirito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "porta-a-prato-san-iacopino-statuto-fortezza": [{
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bolognese": [{
      "hkey": "b34be071",
      "slug": "faentina-trespiano-bolognese",
      "name": "Faentina, Trespiano, Bolognese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1dd709ab": [{
      "hkey": "a65f2fee",
      "slug": "firenze-sud-monteripaldi-ponte-a-ema",
      "name": "Firenze Sud, Monteripaldi, Ponte a Ema",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "b44005e6",
      "slug": "gavinana-viale-europa",
      "name": "Gavinana, Viale Europa",
      "primary": true,
      "skipSearch": false
    }],
    "bellariva-rovezzano": [{
      "hkey": "bb95ce29",
      "slug": "bellariva",
      "name": "Bellariva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "rifredi-careggi": [{
      "hkey": "2f9755c7",
      "slug": "rifredi",
      "name": "Rifredi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "beccaria-oberdan": [{
      "hkey": "87e08f05",
      "slug": "campo-di-marte",
      "name": "Campo Di Marte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "firenze-nord-novoli-nova": [{
      "hkey": "d8f44a57",
      "slug": "firenze-nova-novoli",
      "name": "Firenze Nova, Novoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "galluzzo-certosa": [{
      "hkey": "3b0a8ed3",
      "slug": "bagnese-due-strade-galluzzo",
      "name": "Bagnese, Due Strade, Galluzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "gavinana-europa-firenze-sud": [{
      "hkey": "b44005e6",
      "slug": "gavinana-viale-europa",
      "name": "Gavinana, Viale Europa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "liberta-savonarola": [{
      "hkey": "87e08f05",
      "slug": "campo-di-marte",
      "name": "Campo Di Marte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bellosguardo-galluzzo": [{
      "hkey": "3b0a8ed3",
      "slug": "bagnese-due-strade-galluzzo",
      "name": "Bagnese, Due Strade, Galluzzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "firenze"
    }],
    "bbe4f75a": [{
      "hkey": "96e4b735",
      "slug": "parco-delle-cascine-porta-al-prato-borgo-ognissanti-san-iacopino",
      "name": "Parco delle Cascine, Porta al Prato-Borgo Ognissanti, San Iacopino",
      "primary": true,
      "skipSearch": false
    }],
    "novoli-firenze-nova-firenze-nord": [{
      "hkey": "d8f44a57",
      "slug": "firenze-nova-novoli",
      "name": "Firenze Nova, Novoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ce384f75": [{
      "hkey": "29bddb75",
      "slug": "bellosguardo-legnaia-soffiano",
      "name": "Bellosguardo, Legnaia, Soffiano",
      "primary": false,
      "skipSearch": null
    }, {
      "hkey": "3b0a8ed3",
      "slug": "bagnese-due-strade-galluzzo",
      "name": "Bagnese, Due Strade, Galluzzo",
      "primary": true,
      "skipSearch": null
    }],
    "campo-di-marte-le-cure-coverciano": [{
      "hkey": "87e08f05",
      "slug": "campo-di-marte",
      "name": "Campo Di Marte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "le-piagge-pistoiese": [{
      "hkey": "d8f44a57",
      "slug": "firenze-nova-novoli",
      "name": "Firenze Nova, Novoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;